import { buildApiUrl } from "../utils/apiConfig";
import type { AthleteHomeActionId } from "../polaris-components/athleteHomeActions";

export type AthleteHomeExplorationCompletion = {
    hub: boolean;
    calendar: boolean;
    tutoring: boolean;
};

const EXPLORATION_ACTION_IDS = new Set<AthleteHomeActionId>(["hub", "calendar"]);

export function isExplorationHomeAction(actionId: AthleteHomeActionId): boolean {
    return EXPLORATION_ACTION_IDS.has(actionId);
}

function homeCompletionUrl(context: {
    isAdminViewingAthlete: boolean;
    adminAthleteProfileId?: string;
}): string {
    if (context.isAdminViewingAthlete && context.adminAthleteProfileId) {
        return buildApiUrl(`/api/athletes/${encodeURIComponent(context.adminAthleteProfileId)}/home-completion`);
    }
    return buildApiUrl("/api/athletes/me/home-completion");
}

export async function fetchExplorationHomeCompletion(context: {
    isAdminViewingAthlete: boolean;
    adminAthleteProfileId?: string;
}): Promise<AthleteHomeExplorationCompletion> {
    try {
        const response = await fetch(homeCompletionUrl(context), {
            headers: { Accept: "application/json" },
            credentials: "include",
        });
        if (!response.ok) {
            return { hub: false, calendar: false, tutoring: false };
        }
        return response.json();
    } catch {
        return { hub: false, calendar: false, tutoring: false };
    }
}

export async function markExplorationHomeActionComplete(actionId: AthleteHomeActionId): Promise<void> {
    if (!isExplorationHomeAction(actionId)) {
        return;
    }

    const response = await fetch(buildApiUrl(`/api/athletes/me/home-completion/${encodeURIComponent(actionId)}`), {
        method: "POST",
        credentials: "include",
        headers: { Accept: "application/json" },
    });

    if (!response.ok) {
        throw new Error(`Failed to mark home action complete: ${actionId}`);
    }
}
